import { render, staticRenderFns } from "./taxType.vue?vue&type=template&id=a5c7b002&scoped=true"
import script from "./taxType.vue?vue&type=script&lang=js"
export * from "./taxType.vue?vue&type=script&lang=js"
import style0 from "./taxType.vue?vue&type=style&index=0&id=a5c7b002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c7b002",
  null
  
)

export default component.exports